import type React from "react";

import { Box } from "@mui/material";

import { SkeletonLayout } from "../SkeletonLayout";

const expandIcon = { type: "skeleton", variant: "text", typographyVariant: "body1", width: "50px" } as const;

const widthOptions = ["45%", "55%", "60%"];

interface AccordionSkeletonProps {
  index?: number;
}

export const AccordionSkeleton: React.FC<AccordionSkeletonProps> = ({ index = 0 }) => {
  const width = widthOptions[index % widthOptions.length];
  const summaryText = { type: "skeleton", variant: "text", typographyVariant: "body1", width } as const;
  return (
    <Box
      sx={{
        padding: [1.5, 2],
        border: "1px solid #e0e0e0",
        borderTop: "none",
        overflow: "hidden",
        "&:first-of-type": {
          borderTop: "1px solid #e0e0e0",
          borderRadius: "8px 8px 0 0",
        },
        "&:last-of-type": {
          borderRadius: "0 0 8px 8px",
        },
        "&:only-of-type": {
          borderRadius: "8px",
        },
      }}
    >
      <SkeletonLayout
        layout={{
          type: "row",
          gap: 2,
          alignItems: "center",
          justifyContent: "space-between",
          children: [summaryText, expandIcon],
        }}
      />
    </Box>
  );
};
